export enum ReadingLevelOptions {
  SEQUENTIAL= "SEQUENTIAL",
  SMART = "SMART",
}
